var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vrstva_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "8 8 24 24",
    enableBackground: "new 8 8 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "24.502,19.802 22.568,18.007 19.245,21.587 17.169,19.9 15.506,21.947 19.498,25.191  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.113,8H11.216H9.897l-0.003,5.276H9.887v2.638h0.005l-0.005,7.728c0,1.128,0.584,2.114,1.447,2.689 l0.005,0.004L20,32l8.65-5.665l0.006-0.004c0.861-0.575,1.445-1.561,1.445-2.688c0-0.001,0-0.001,0-0.001l0.006-7.728h0.004v-2.638 h-0.002L30.113,8z M12.534,10.638h14.938l-0.002,2.638H12.532L12.534,10.638z M27.465,23.642c0,0.193-0.1,0.378-0.27,0.493 l-7.196,4.713l-7.205-4.713c-0.17-0.115-0.269-0.3-0.269-0.493l0.005-7.728h14.938L27.465,23.642z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/shield.f2754a307c3b6952247b54059d0bb852.svg";
export { ForwardRef as ReactComponent };